import { Injectable, inject } from "@angular/core";

import { AnalyticsService, EVENT_UAEVENT } from "@hermes/hermes-web-fragments-analytics";

const LEGAL_CONTACT_US = "Help";

@Injectable()
export class CustomerServiceContactAnalyticsService {
    private analyticsService = inject(AnalyticsService);

    public sendClickContactUs(action: string): void {
        this.analyticsService.sendRawData({
            event: EVENT_UAEVENT,
            eventcategory: LEGAL_CONTACT_US,
            eventaction: "Contact",
            eventlabel: action,
        });
    }
}
